/**
 * usePermissions Hook
 * ฮุคสำหรับตรวจสอบสิทธิ์
 *
 * Lightweight hook for permission checking in components.
 * ฮุคน้ำหนักเบาสำหรับตรวจสอบสิทธิ์ในคอมโพเนนต์
 */

import { useCallback } from 'react'
import { useAuthStore } from './auth.store'
import { hasPermission, hasAnyPermission, hasAllPermissions } from '@/shared/logic/acl.logic'
import type { Permission } from '@/shared/types/permissions'

export const usePermissions = () => {
  const permissions = useAuthStore((s) => s.user?.permissions ?? [])

  /** Check if user has a specific permission */
  const can = useCallback(
    (permission: Permission) => hasPermission(permissions, permission),
    [permissions]
  )

  /** Check if user has any of the given permissions */
  const canAny = useCallback(
    (perms: Permission[]) => hasAnyPermission(permissions, perms),
    [permissions]
  )

  /** Check if user has all of the given permissions */
  const canAll = useCallback(
    (perms: Permission[]) => hasAllPermissions(permissions, perms),
    [permissions]
  )

  return { can, canAny, canAll, permissions }
}
